// 9fbef606107a605d69c0edbcd8029e5d
import addCustomerPaymentInstrument from '@tcp/core/src/queries/addCustomerPaymentInstrument.query.graphql';
import updateCustomerPaymentInstrument from '@tcp/core/src/queries/updateCustomerPaymentInstrument.query.graphql';
import { executeStatefulGraphQLQuery } from '../../handler';
import { getAPIConfig, getDateObject } from '../../../utils';
import constants from '../../../components/features/account/AddEditCreditCard/container/AddEditCreditCard.constants';

const errorHandler = (err) => {
  if (err) {
    throw err;
  }
  throw new Error('Your action could not be completed due to system error');
};

// eslint-disable-next-line complexity, sonarjs/cognitive-complexity
const formattedAddress = (args) => {
  const apiConfig = getAPIConfig();
  if (args.addressId) {
    return {
      c_addressId: args.addressId,
    };
  }
  const internationalCountry =
    (args.countryCode && args.countryCode !== 'US' && args.countryCode !== 'CA') ||
    (args.country && args.country !== 'US' && args.country !== 'CA');
  return {
    address1: args.address1 || args.addressLine1 || '',
    address2: args.address2 || args.addressLine2 || '',
    c_billing_addressField3: args.address1 || args.addressLine1 || '',
    c_billing_nickName:
      args.nickName || `Billing_${apiConfig.storeId}_${getDateObject().getTime().toString()}`,
    c_addressId: args.addressId || '',
    c_addressType: 'Billing',
    c_validationCode: args.validationCode || '',
    c_emailAddress: args.email || '',
    city: args.city,
    countryCode: args.countryCode || args.country || '',
    firstName: args.firstName,
    fullName: `${args.firstName} ${args.lastName}`,
    lastName: args.lastName,
    phone: args.phoneNumber || '',
    postalCode: internationalCountry
      ? args.zipCodeInternational || ''
      : args.zipCode || args.postalCode || '',
    stateCode: args.stateCode || args.state,
  };
};

export const addPaymentInstruction = (args) => {
  const formattedBillingAddress = formattedAddress(args);
  let paymentInstrument;
  let addCustomerPaymentInstrumentPaymentMethodType = '';
  if (constants.PLCC_CARDS.includes(args.cardType)) {
    addCustomerPaymentInstrumentPaymentMethodType = 'ADS_PLCC';
    paymentInstrument = {
      cardNumber: args.cardNumber,
      isDefaultPayment: !!args.isDefault,
    };
  } else {
    addCustomerPaymentInstrumentPaymentMethodType = 'CREDIT_CARD';
    paymentInstrument = {
      sessionId: args.paySecureSessionId,
      isDefaultPayment: !!args.isDefault,
    };
  }

  const queryPayload = {
    addCustomerPaymentInstrumentPaymentMethodType,
    addCustomerPaymentInstrumentRequest: {
      billingAddress: formattedBillingAddress,
      paymentInstrument,
      recaptureResponse: args.recaptchaToken,
    },
  };

  const payload = {
    query: addCustomerPaymentInstrument,
    variables: queryPayload,
    type: 'mutation',
  };
  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      const billingMethodResp = res.data && res.data.addPaymentInstruments;
      const customerPaymentInstrument =
        res.data &&
        res.data.addCustomerPaymentInstrument &&
        res.data.addCustomerPaymentInstrument.customerPaymentInstrument;
      return {
        billingMethodResp,
        customerPaymentInstrument,
      };
    })
    .catch((err) => {
      throw errorHandler(err);
    });
};

// eslint-disable-next-line sonarjs/cognitive-complexity
export const updatePaymentInstruction = (args) => {
  const paymentInstrument = {
    paymentInstrumentId: args?.creditCardId,
    isDefaultPayment: !!args.isDefault,
  };
  let updateCustomerPaymentInstrumentPaymentMethodType = '';
  if (constants.PLCC_CARDS.includes(args.cardType)) {
    updateCustomerPaymentInstrumentPaymentMethodType = 'ADS_PLCC';
    paymentInstrument.cardNumber = args.cardNumber;
  } else {
    updateCustomerPaymentInstrumentPaymentMethodType = 'CREDIT_CARD';
    if (!args?.maskedNumber) {
      paymentInstrument.sessionId = args?.paySecureSessionId;
    } else {
      paymentInstrument.expirationMonth = args?.expMonth;
      paymentInstrument.expirationYear = args?.expYear;
    }
    if (args.cvvCode) {
      paymentInstrument.cvv = args.cvvCode;
    }
  }

  const updateCustomerPaymentInstrumentRequest = {
    paymentInstrument,
    recaptureResponse: args.recaptchaToken,
  };
  const internationalCountry =
    (args.countryCode && args.countryCode !== 'US' && args.countryCode !== 'CA') ||
    (args.country && args.country !== 'US' && args.country !== 'CA');
  if (args.addressId) {
    if (args.addressId !== args?.prevCreditCard?.billingAddressId) {
      updateCustomerPaymentInstrumentRequest.billingAddress = {
        c_addressId: args.addressId,
        postalCode: internationalCountry
          ? args.zipCodeInternational || ''
          : args.zipCode || args.postalCode || '',
        stateCode: args.stateCode || args.state,
      };
    }
  } else {
    updateCustomerPaymentInstrumentRequest.billingAddress = formattedAddress(args);
  }

  const queryPayload = {
    updateCustomerPaymentInstrumentPaymentMethodType,
    updateCustomerPaymentInstrumentRequest,
  };

  const payload = {
    query: updateCustomerPaymentInstrument,
    variables: queryPayload,
    type: 'mutation',
  };
  return executeStatefulGraphQLQuery(payload)
    .then((res) => {
      const billingMethodResp = res.data && res.data.updateCustomerPaymentInstrument;
      return {
        billingMethodResp,
      };
    })
    .catch((err) => {
      throw errorHandler(err);
    });
};
